import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { PublicOrderItemComponentResponse } from './public-order-item-component.response';

@jsonObject
export class PublicOrderItemComponentGroupResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Boolean)
  public readonly isRandomSelected!: boolean;

  @jsonArrayMember(PublicOrderItemComponentResponse)
  public readonly components!: PublicOrderItemComponentResponse[];
}
